import React from "react"
import {
  partenairesContainer,
  partenairesTitle,
  partenairesDescription,
} from "./partenaires.module.scss"
import { PartenaireTitle } from "./partenaires-styled"
import ContentTransformer from "gatsby-theme-blank/src/components/Transformers/content-transformer"
import { usePartenaires } from "gatsby-theme-blank/src/components/Home/Partenaires/partenaires-query"
import RenderPartenaires from "./RenderPartenaires/render-partenaires"

//-----------------------Parent component---------------------------//

const ListPartenaires = () => {
  const data = usePartenaires()
  const partenaireItem = data.allDirectLinkEntityDirectLinkEntity.edges
  if (partenaireItem.length > 0) {
    return (
      <>
        <PartenaireTitle className={partenairesTitle}>
          {data.taxonomyTermTypeDeLienDirect?.field_label || "Partenaires"}
        </PartenaireTitle>
        {data.taxonomyTermTypeDeLienDirect.description && (
          <div className={partenairesDescription}>
            <ContentTransformer
              content={data.taxonomyTermTypeDeLienDirect.description.processed}
            ></ContentTransformer>
          </div>
        )}
        <div className={partenairesContainer}>
          <RenderPartenaires partenairesData={data} />
        </div>
      </>
    )
  }
  return null
}
//-----------------------Parent component---------------------------//

export default ListPartenaires
